'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UICheckbox from 'UIComponents/input/UICheckbox';
import HelpTooltip from 'ContentComponents/cmv2/HelpTooltip';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { ALLOW_CUSTOM_BORDER_SIDES } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { BORDER } from 'ContentUtils/constants/CustomWidgetFieldTypes';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.editorOptions.${key}`;

const BorderSidesToggle = ({
  editField,
  field
}) => {
  const onToggleCustomBorderSides = e => {
    editField({
      [ALLOW_CUSTOM_BORDER_SIDES]: e.target.checked
    });
  };

  const {
    type: fieldType
  } = field;
  const checked = field[ALLOW_CUSTOM_BORDER_SIDES];
  if (fieldType !== BORDER) return null;
  return /*#__PURE__*/_jsxs(UICheckbox, {
    checked: checked,
    onChange: onToggleCustomBorderSides,
    children: [/*#__PURE__*/_jsx(UIFormLabel, {
      className: "p-top-0 p-right-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('allowCustomBorderSides')
      })
    }), /*#__PURE__*/_jsx(HelpTooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('allowCustomBorderSidesTooltip')
      })
    })]
  });
};

BorderSidesToggle.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired
};
export default BorderSidesToggle;